import { render, staticRenderFns } from "./ReferralOptions.vue?vue&type=template&id=1c95811f&"
import script from "./ReferralOptions.vue?vue&type=script&lang=js&"
export * from "./ReferralOptions.vue?vue&type=script&lang=js&"
import style0 from "./ReferralOptions.vue?vue&type=style&index=0&id=1c95811f&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c95811f')) {
      api.createRecord('1c95811f', component.options)
    } else {
      api.reload('1c95811f', component.options)
    }
    module.hot.accept("./ReferralOptions.vue?vue&type=template&id=1c95811f&", function () {
      api.rerender('1c95811f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Vouchers/ReferralOptions.vue"
export default component.exports